// Global Studio metronome. Clicks are scheduled on the AudioContext clock
// (same timeline as the beat) straight to the speakers — they never pass
// through the master bus, the mic recorder or the Final Mix.
const LOOKAHEAD_SEC = 0.15;
const TICK_MS = 25;

export class Metronome {
  constructor(ctx) {
    this.ctx = ctx;
    this.out = ctx.createGain();
    this.out.gain.value = 0.35;
    this.out.connect(ctx.destination);
    this.timer = null;
  }

  // t0 = ctx time where timeline position `fromSec` plays.
  start(t0, fromSec, bpm) {
    this.stop();
    const spb = 60 / Math.max(30, Math.min(300, bpm || 90));
    let n = Math.ceil(fromSec / spb - 1e-6);
    const at = (k) => t0 + (k * spb - fromSec);
    const pump = () => {
      const horizon = this.ctx.currentTime + LOOKAHEAD_SEC;
      while (at(n) < horizon) {
        if (at(n) >= this.ctx.currentTime - 0.01) this._click(at(n), n % 4 === 0);
        n += 1;
      }
    };
    pump();
    this.timer = setInterval(pump, TICK_MS);
  }

  _click(when, accent) {
    const osc = this.ctx.createOscillator();
    const env = this.ctx.createGain();
    osc.frequency.value = accent ? 1600 : 1000;
    env.gain.setValueAtTime(0.0001, when);
    env.gain.exponentialRampToValueAtTime(accent ? 1 : 0.6, when + 0.002);
    env.gain.exponentialRampToValueAtTime(0.0001, when + 0.05);
    osc.connect(env).connect(this.out);
    osc.start(when);
    osc.stop(when + 0.06);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}

export default Metronome;
